import { render, staticRenderFns } from "./CourseCardV2.vue?vue&type=template&id=5b9c5a81&scoped=true"
import script from "./CourseCardV2.vue?vue&type=script&lang=js"
export * from "./CourseCardV2.vue?vue&type=script&lang=js"
import style0 from "./CourseCardV2.vue?vue&type=style&index=0&id=5b9c5a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c5a81",
  null
  
)

export default component.exports